<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} User Plan</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label :for="field.name">{{ field.label }}:</label>
              <input class="checkbox" v-if="field.name === 'active' || field.name === 'status' || field.name === 'cpayPayment'"
                     type="checkbox" :id="field.name" v-model="editedConfig[field.name]">
              <input v-else :id="field.name" v-model="editedConfig[field.name]"
                     :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${String(editedConfig[field.name]).length * 10}px` : '100px' }"
                     type="text" class="form-control"
                     :disabled="field.name === 'userPlanId' || field.name === 'startDate' || field.name === 'created'"
                     :required="['userId', 'planId', 'startDate', 'endDate'].includes(field.name)">
            </div>
            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <button type="submit" class="procricket-btn">Save changes</button>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {UserPlan} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'UserPlanEdit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        userPlanId : this.$route.params.userPlanId,
        userId : this.$route.params.userId,
        planId : this.$route.params.planId,
        couponCode: this.$route.params.couponCode,
        startDate : this.$route.params.startDate,
        endDate : this.$route.params.endDate,
        trialActivationCode : this.$route.params.trialActivationCode,
        stripeInvoice : this.$route.params.stripeInvoice,
        stripeConfigurationId : this.$route.params.stripeConfigurationId,
        paypalConfigurationId : this.$route.params.paypalConfigurationId,
        paypalOrderId : this.$route.params.paypalOrderId,
        paypalCaptureId : this.$route.params.paypalCaptureId,
        plisioConfigurationId : this.$route.params.plisioConfigurationId,
        plisioTxnId : this.$route.params.plisioTxnId,
        squareConfigurationId : this.$route.params.squareConfigurationId,
        squareOrderId : this.$route.params.squareOrderId,
        cpayPayment : this.$route.params.cpayPayment,
        stripePaidAmount : this.$route.params.stripePaidAmount,
        stripePaymentDate : this.$route.params.stripePaymentDate,
        created : this.$route.params.created,
        updated : this.$route.params.updated,
        active: this.$route.params.active,
        status: this.$route.params.status,
      },
      editMode: false,
      fields: [
        { name: "userPlanId", label: "User Plan Id" },
        { name: "userId", label: "User Id" },
        { name: "planId", label: "Plan Id" },
        { name: "couponCode", label: "Coupon Code"},
        { name: "startDate", label: "Start Date" },
        { name: "endDate", label: "End Date" },
        { name: "trialActivationCode", label: "Trial Activation Code" },
        { name: "stripeInvoice", label: "Stripe Invoice" },
        { name: "stripeConfigurationId", label: "Stripe Configuration Id" },
        { name: "paypalConfigurationId", label: "Paypal Configuration Id" },
        { name: "paypalOrderId", label: "Paypal Order Id" },
        { name: "paypalCaptureId", label: "Paypal Capture Id" },
        { name: "plisioConfigurationId", label: "Plisio Configuration Id" },
        { name: "plisioTxnId", label: "Plisio Txn Id" },
        { name: "squareConfigurationId", label: "Square Configuration Id" },
        { name: "squareOrderId", label: "Square Order Id" },
        { name: "cpayPayment", label: "CPay Payment" },
        { name: "stripePaidAmount", label: "Stripe Paid Amount" },
        { name: "stripePaymentDate", label: "Stripe Payment Date" },
        { name: "created", label: "Created" },
        { name: "updated", label: "Updated" },
        { name: "active", label: "Active" },
        { name: "status", label: "Status" },
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.userPlanId) {
      this.editMode = true;
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new UserPlan(
          this.editedConfig.userPlanId,
          this.editedConfig.userId,
          this.editedConfig.planId,
          this.editedConfig.couponCode,
          this.editedConfig.startDate,
          this.editedConfig.endDate,
          this.editedConfig.trialActivationCode,
          this.editedConfig.stripeInvoice,
          this.editedConfig.stripeConfigurationId,
          this.editedConfig.paypalConfigurationId,
          this.editedConfig.paypalOrderId,
          this.editedConfig.paypalCaptureId,
          this.editedConfig.plisioConfigurationId,
          this.editedConfig.plisioTxnId,
          this.editedConfig.squareConfigurationId,
          this.editedConfig.squareOrderId,
          this.editedConfig.cpayPayment || false,
          this.editedConfig.stripePaidAmount,
          this.editedConfig.stripePaymentDate,
          this.editedConfig.active || false,
          this.editedConfig.status || false,
          this.editedConfig.created,
          this.editedConfig.updated
      );

      if (this.editMode) {
        AdminService.updateUserPlan(dataToSave).then(() => {
          alert('Update complete');
          if (window.history.length > 1) {
            this.$router.back();
          } else {
            this.$router.push({ name: 'UserPlans' });
          }
        }).catch((error) => {
          console.error("Error updating Users:", error);
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      } else {
        AdminService.insertUserPlan(dataToSave).then(() => {
          alert('Insert complete');
          this.$router.push({ name: 'UserPlans' });
        }).catch((error) => {
          this.error = error.message
        });
      }
    }
  }
})
</script>
<style src="../../assets/style.css">
</style>
